export const state = {
    collapsed: null,
    active: null,
    opens: [],
    mobile: false,
    drawer: false,
    small: false,
    type: null,
    theme: 'dark',
    routes: {}
};
